import { render } from "./TemplateDownloadModal.vue?vue&type=template&id=1181a592"
import script from "./TemplateDownloadModal.vue?vue&type=script&lang=js"
export * from "./TemplateDownloadModal.vue?vue&type=script&lang=js"

import exportComponent from "/mudfix/license/ui-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__